module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/5-off-3088cace604532c57d637f12c4bc089c.png";